<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    modelValue: {
      required: false,
      type: null,
    },
    value: {
      required: false,
      type: null,
    },
    onValue: {
      type: null,
      default: true,
    },
    offValue: {
      type: null,
      default: false,
    },
  },
  emits: ["update:modelValue", "change"],
  computed: {
    checked() {
      return this.value === this.onValue || this.modelValue === this.onValue;
    },
  },
});
</script>

<template>
  <div
    class="toggle"
    :class="{ checked }"
    @click="
      $emit('update:modelValue', modelValue === onValue ? offValue : onValue);
      $emit('change', value === onValue ? offValue : onValue);
    "
  ></div>
</template>

<style>
.toggle {
  @apply relative;

  width: 29px;
  height: 16px;

  border-radius: 30px;

  box-shadow: inset 0 2px 10px rgba(1, 27, 38, 0.2);
}

.toggle.checked {
  @apply bg-midblue;
  @apply duration-200;
}

.toggle::after {
  @apply duration-200;
  content: "";
  position: absolute;
  @apply bg-white;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  top: 1px;

  right: 13px;
}

.toggle.checked::after {
  right: 2px;
}
</style>
